// Import model
import { FilterTaxRatesRequest } from '../models/FilterTaxRatesRequest';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { TaxRatesCondition } from '../models/TaxRatesCondition';
import { TaxRatesFields } from '../models/TaxRatesFields';
import { TaxRatesIndexedFields } from '../models/TaxRatesIndexedFields';

// Import dependency serializers (for complex types)
import { TaxRatesConditionSerializer } from './TaxRatesConditionSerializer';
import { TaxRatesFieldsSerializer } from './TaxRatesFieldsSerializer';
import { TaxRatesIndexedFieldsSerializer } from './TaxRatesIndexedFieldsSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for FilterTaxRatesRequest - handles JSON serialization and deserialization with type validation
 */
export class FilterTaxRatesRequestSerializer {
  /**
   * Deserializes a JSON string into a FilterTaxRatesRequest instance
   */
  static deserialize(json: string): FilterTaxRatesRequest {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a FilterTaxRatesRequest instance
   */
  static fromObject(obj: any): FilterTaxRatesRequest {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to FilterTaxRatesRequest');
    }


    const instance: FilterTaxRatesRequest = {
      top: obj['top'] as number | undefined,
      skip: obj['skip'] as number | undefined,
      orderBy: obj['orderBy'] as TaxRatesIndexedFields | undefined,
      reverseOrder: obj['reverseOrder'] as boolean | undefined,
      view: obj['view'] as string | undefined,
      fields: obj['fields'] ? (obj['fields'] as any[]).map((item: any) =>
        item as TaxRatesFields
      ) : [] as any,
      criteria: obj['criteria'] ? (obj['criteria'] as any[]).map((item: any) =>
        TaxRatesConditionSerializer.fromObject(item)
      ) : [] as any,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of FilterTaxRatesRequest instances
   */
  static deserializeArray(json: string): FilterTaxRatesRequest[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a FilterTaxRatesRequest instance to a JSON string
   */
  static serialize(instance: FilterTaxRatesRequest): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a FilterTaxRatesRequest instance to a plain object
   */
  static toObject(instance: FilterTaxRatesRequest): any {
    return {
      'top': instance.top,
      'skip': instance.skip,
      'orderBy': instance.orderBy,
      'reverseOrder': instance.reverseOrder,
      'view': instance.view,
      'fields': instance.fields?.map((item: any) =>
        item
      ),
      'criteria': instance.criteria?.map((item: any) =>
        TaxRatesConditionSerializer.toObject(item)
      ),
    };
  }

  /**
   * Serializes an array of FilterTaxRatesRequest instances to a JSON string
   */
  static serializeArray(instances: FilterTaxRatesRequest[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
